import { useUpdateMaterialLayout } from "#modules/materialLayouts/view/useUpdateMaterialLayout";
import { useCustomMaterials } from "#modules/materials/view/useCustomMaterials";
import { getMaterialDensity, MaterialGradeType, MaterialLayout } from "shared";

type Params = {
  materialLayout: MaterialLayout | null;
  materialGrade: MaterialGradeType;
  quoteRequestLineId: string | undefined;
};

export const useUpdateLayoutMaterial = ({
  materialLayout,
  materialGrade,
  quoteRequestLineId,
}: Params) => {
  const { customMaterials } = useCustomMaterials({});
  const { updateMaterialLayout, isPending } = useUpdateMaterialLayout({
    quoteRequestLineId,
  });

  const buildUpdate = (newMaterialId: string) => {
    const newMaterial = customMaterials.find((cm) => cm.id === newMaterialId);

    if (!newMaterial || !materialLayout?.id) {
      return null;
    }

    return {
      id: materialLayout.id,
      payload: {
        data: {
          density: newMaterial.density ?? getMaterialDensity({ materialGrade }),
          height: newMaterial.height,
          length: newMaterial.length,
          tubeThickness: newMaterial.tubeThickness,
          width: newMaterial.width,
          price: newMaterial.price,
          materialId: newMaterial.id,
          volumetricPrice: null,
          materialVolumetricId: null,
        },
      },
    };
  };

  const updateLayoutMaterial = (
    newMaterialId: string,
    mutateOptions?: Parameters<typeof updateMaterialLayout>[1],
  ) => {
    const update = buildUpdate(newMaterialId);
    if (update) {
      updateMaterialLayout(update, mutateOptions);
    }
  };

  return { updateLayoutMaterial, isPending };
};
